export const useButtonConfigs = (
  setPopupDragAndDrop,
  setThemesModal,
  setExit,
  selectedTheme,
  theme,
  setConfirmTheme,
  setMessageError
) => {
  const settingsButton = {
    text: "Configurações",
    icon: "preferences",
    onClick: () => setPopupDragAndDrop(true),
  };

  const changeTheme = {
    text: "Temas",
    icon: "palette",
    onClick: () => setThemesModal(true),
  };

  const logOut = {
    text: "Sair",
    icon: "arrowright",
    onClick: () => setExit((prev) => ({ ...prev, isVisible: true })),
  };

  const hestiaOptions = {
    text: "Hestia",
    icon: "menu",
    hoverStateEnabled: true,
  };

  const choosedTheme = {
    text: "Ok",
    icon: "check",
    type: "default",
    stylingMode: "default",
    onClick: () => {
      if (theme) {
        setConfirmTheme((prev) => ({ ...prev, isVisible: true }));
        setMessageError({ message: "" });
      } else {
        setMessageError({
          message: "Você precisa selecionar um tema para prosseguir. ⚠⚠",
        });
      }
    },
  };

  const closeChoosedTheme = {
    text: "Cancelar",
    icon: "chevronleft",
    onClick: () => {
      setMessageError({ message: "" });
      setThemesModal(false);
    },
  };

  const closeConfirmTheme = {
    text: "Cancelar",
    icon: "chevronleft",
    onClick: () => setConfirmTheme((prev) => ({ ...prev, isVisible: false })),
  };

  const confirmButtonSelectedTheme = {
    text: "Mudar Tema",
    icon: "color",
    type: "default",
    stylingMode: "default",
    onClick: () => selectedTheme(theme),
  };

  const confirmExit = {
    text: "Sair",
    icon: "export",
    type: "default",
    stylingMode: "default",
    onClick: () => {
      window.location.href = "";
      sessionStorage.clear();
    },
  };

  const closeExit = {
    text: "Cancelar",
    icon: "close",
    onClick: () => setExit((prev) => ({ ...prev, isVisible: false })),
  };

  return {
    settingsButton,
    changeTheme,
    logOut,
    hestiaOptions,
    choosedTheme,
    closeChoosedTheme,
    closeConfirmTheme,
    confirmButtonSelectedTheme,
    confirmExit,
    closeExit,
  };
};
